import { Inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Metas, SeoService } from '../../shared/services/utilities/seo.service';
import { environment } from 'environments/environment';
import { getTranslation } from '../../utils/const/translation';
//import {Client, CookieTokenStorage} from '@adeo/kazaplan-sdk';
import {isPlatformBrowser} from "@angular/common";
import { Observable } from 'rxjs';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { MediaResponse, Plan } from '@adeo/ngx-kozikaza-api/kazaplan';
import { Media } from '@adeo/ngx-kozikaza-api';
//import { Media, MediaResponse, Plan } from '@adeo/ngx-kozikaza-api/kazaplan';


@Injectable()
export class KazaplanService {

  config = {
    'locale': 'fr',
    'apiBaseUrl': environment.API_KAZAPLAN,
    'tokenStorage': null
  };

 // public client: Client;
  constructor(
    private seoService: SeoService,
    private router: Router,
    private http:HttpClient,
    private cookiesService:CookieService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.config.locale = locale;
    if (isPlatformBrowser(platformId)) {
    /*  this.config.tokenStorage = new CookieTokenStorage((environment.env === 'prod' ? '' : environment.env + '_') + 'kozikaza_token_accessToken');
      this.config.locale = locale;
      this.client = new Client(this.config);*/
    }
  }

  public initMetas(kazaplan: Plan, medias: MediaResponse, activatedRoute?: ActivatedRouteSnapshot, initMetasFromRoute = false): Metas {
    const route = (activatedRoute) ? activatedRoute : this.activatedRoute;
    const titleKey = (route.data && route.data.metas && route.data.metas.titleKey) ? route.data.metas.titleKey : 'meta.kazaplan.title-edit';
    const title = getTranslation(titleKey, {planName : kazaplan.title} );
    const image = (medias && medias.total > 0) ? medias.data[0].fileUrl : `${environment.REDIRECT_URL}/assets/images/header/logo.png`;
    const descriptionKey = (route.data && route.data.metas && route.data.metas.descriptionKey) ? route.data.metas.descriptionKey : null;
    const desc = (descriptionKey) ? getTranslation(descriptionKey) : '';
    const metas = {title, description : desc, image};
    if (!initMetasFromRoute) {
      this.seoService.setMetas({ ...route.data.metas , ...metas});
    }
    return metas;
  }

  get activatedRoute(): ActivatedRouteSnapshot {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot;
  }

  getKazaplanMetas(kazaplan: Plan, kazaplanMedia?: any): Metas { //to be checked
    const title = $localize`:@@meta.kazaplan.kazaplan-main.title:3D Plan ${kazaplan.title}:planName: | Kozikaza`;

    const image = (kazaplanMedia && kazaplanMedia.fileUrl) ? kazaplanMedia.fileUrl : `${environment.REDIRECT_URL}/assets/images/header/logo.png`;
    return {title, image};
  }
  public getHeaders(): HttpHeaders {
    const bearerToken = this.cookiesService.get(environment.KZP_ACCES_TOKEN);
     return new HttpHeaders({
      Authorization: `Bearer ${bearerToken}`,
    });
  }

}
